<template>
  <v-container>
    <v-row
      class="box"
      :style="{
        background: setBackgoundBox(),
        borderRadius: isSticky ? '' : '28px',
      }"
      ><v-col cols="12" align-self="center">
        <v-row>
          <v-col cols="auto" align-self="center" style="z-index: 1"
            ><div
              class="d-flex justify-center align-center"
              style="width: 96px; height: 96px"
            >
              <v-avatar size="72">
                <v-img
                  :src="dataItems.image ? dataItems.image : defaultImage"
                  @error="onImageError(dataItems, 'image')"
                ></v-img>
              </v-avatar></div
          ></v-col>
          <v-col
            class="pl-0 pr-6 d-flex justify-center align-center"
            style="width: calc(100% - 140px); z-index: 1"
          >
            <v-row no-gutters>
              <v-col cols="auto">
                <div
                  style="font-size: 28px; font-weight: bold; margin-right: 8px"
                  :style="{
                    color: this.customHeader.titleColor,
                  }"
                >
                  {{ $t("textWelcome") }}
                </div>
                <div
                  style="font-size: 16px"
                  :style="{
                    color: this.customHeader.titleColor,
                  }"
                >
                  {{ fullname }}
                </div>
              </v-col>
            </v-row>
          </v-col>
          <div
            v-if="!customHeader.isUseCustomHeader"
            class="style-box"
            :style="{
              width: isSticky ? '100%' : 'calc(100% - 24px)',
            }"
          >
            <div
              class="style-sub-box"
              :style="{
                borderRadius: isSticky ? '' : '28px',
              }"
            >
              <svg viewBox="0 0 1440 800" preserveAspectRatio="xMIdYMid slice">
                <defs>
                  <!-- Gradient for main background (white/very light grey) -->
                  <linearGradient
                    id="mainBgGradient"
                    x1="0%"
                    y1="0%"
                    x2="100%"
                    y2="100%"
                  >
                    <stop offset="0%" stop-color="#ffffff" />
                    <!-- White -->
                    <stop offset="100%" stop-color="#f8fafc" />
                    <!-- Very Light Blue-Grey -->
                  </linearGradient>

                  <!-- Gradient for main shapes (white/light grey for CRM/Connection) -->
                  <linearGradient
                    id="shapeGradient1"
                    x1="0%"
                    y1="0%"
                    x2="100%"
                    y2="100%"
                  >
                    <stop offset="0%" stop-color="#f0f0f0" />
                    <!-- Light Grey -->
                    <stop offset="100%" stop-color="#e0e0e0" />
                    <!-- Slightly Darker Light Grey -->
                  </linearGradient>

                  <!-- Gradient for secondary shapes (white/light grey for Points/Flow) -->
                  <linearGradient
                    id="shapeGradient2"
                    x1="0%"
                    y1="0%"
                    x2="100%"
                    y2="100%"
                  >
                    <stop offset="0%" stop-color="#e8e8e8" />
                    <!-- Lighter Grey -->
                    <stop offset="100%" stop-color="#d8d8d8" />
                    <!-- Mid Grey -->
                  </linearGradient>

                  <!-- Gradient for star icon (white/light grey) -->
                  <linearGradient
                    id="starGradient"
                    x1="0%"
                    y1="0%"
                    x2="100%"
                    y2="100%"
                  >
                    <stop offset="0%" stop-color="#f0f0f0" />
                    <!-- Light Grey -->
                    <stop offset="100%" stop-color="#e0e0e0" />
                    <!-- Slightly Darker Light Grey -->
                  </linearGradient>

                  <!-- Gradient for gift icon (white/light grey) -->
                  <linearGradient
                    id="giftGradient"
                    x1="0%"
                    y1="0%"
                    x2="100%"
                    y2="100%"
                  >
                    <stop offset="0%" stop-color="#e8e8e8" />
                    <!-- Lighter Grey -->
                    <stop offset="100%" stop-color="#d8d8d8" />
                    <!-- Mid Grey -->
                  </linearGradient>
                </defs>

                <!-- Main background - increased opacity for overall transparency -->
                <rect
                  width="100%"
                  height="100%"
                  fill="url(#mainBgGradient)"
                  fill-opacity="0.1"
                />

                <!-- Abstract shapes representing connection/data (CRM) - increased opacity -->
                <path
                  fill="url(#shapeGradient1)"
                  fill-opacity="0.1"
                  d="M0,160 C150,250 300,100 450,200 C600,300 750,150 900,250 C1050,350 1200,200 1440,300 L1440,0 L0,0 Z"
                />
                <path
                  fill="url(#shapeGradient2)"
                  fill-opacity="0.06"
                  d="M0,220 C180,120 360,300 540,200 C720,100 900,280 1080,180 C1260,80 1440,250 1440,250 L1440,0 L0,0 Z"
                />

                <!-- Circle/dot shapes (Points/Rewards) - increased opacity -->
                <circle
                  cx="100"
                  cy="500"
                  r="80"
                  fill="url(#shapeGradient1)"
                  fill-opacity="0.15"
                />
                <circle
                  cx="1300"
                  cy="200"
                  r="60"
                  fill="url(#shapeGradient2)"
                  fill-opacity="0.12"
                />
                <circle
                  cx="700"
                  cy="650"
                  r="100"
                  fill="url(#shapeGradient1)"
                  fill-opacity="0.1"
                />
                <circle
                  cx="400"
                  cy="100"
                  r="40"
                  fill="url(#shapeGradient2)"
                  fill-opacity="0.15"
                />
                <circle
                  cx="1100"
                  cy="700"
                  r="70"
                  fill="url(#shapeGradient1)"
                  fill-opacity="0.12"
                />

                <!-- SVG icons for rewards/gifts (can be adjusted) - increased opacity -->
                <!-- Star icon (Points/Loyalty) -->
                <g transform="translate(200, 400) scale(0.8)">
                  <path
                    class="icon-star"
                    fill-opacity="0.25"
                    d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
                  />
                </g>
                <!-- Gift box icon (Redemption) -->
                <g transform="translate(950, 500) scale(0.7)">
                  <path
                    class="icon-gift"
                    fill-opacity="0.25"
                    d="M20 12h-2V7h-4V5h-4v2H4v5H2v2h2v4h16v-4h2v-2zm-4 6H8v-4h8v4zm2-6h-2V9h-4V7h-4v2H6v3h-2v-2h16v2z"
                  />
                </g>
              </svg>
            </div>
          </div>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {
  adjustHslBrightness,
  getFontColorBasedOnBg,
} from "@/config/general-function";
import { checkImage } from "../../config/general-function";

export default {
  props: ["isSticky", "site", "fullname", "image"],
  data() {
    return {
      dataItems: {
        image: "",
      },
      customHeaderPage: "main",
      customHeader: {
        isUseCustomHeader: false,
        isUseTitle: true,
        image: "",
        titleColor: "#ffffff",
      },
    };
  },
  async created() {
    // ========== ========== ========== ==========
    if (this.site?.page_header_cover[this.customHeaderPage]) {
      this.customHeader.isUseCustomHeader =
        this.site?.page_header_cover[
          this.customHeaderPage
        ].is_use_custom_header;
      this.customHeader.isUseTitle =
        this.site?.page_header_cover[this.customHeaderPage].is_use_title;
      const page_header_cover_image =
        this.site?.page_header_cover[this.customHeaderPage].image;
      const _check_image = await checkImage(page_header_cover_image);
      this.customHeader.image = _check_image ? page_header_cover_image : null;

      this.customHeader.titleColor = "#ffffff";
      if (this.customHeader.isUseCustomHeader) {
        this.customHeader.titleColor =
          this.site?.page_header_cover[this.customHeaderPage].title_color ||
          "#ffffff";
      }
    }
  },
  methods: {
    onImageError(item, key) {
      item[key] = null;
    },
    getFontColorBasedOnBg(param, param2) {
      const res = getFontColorBasedOnBg(param, param2);
      return res;
    },
    setBackgoundBox() {
      const _color = this.site.color || "#00000";
      const darken = adjustHslBrightness(_color, -20);
      let _style = `linear-gradient(120deg, ${_color}, ${darken})`;
      if (this.customHeader.isUseCustomHeader && this.customHeader.image) {
        _style = `url("${this.customHeader.image}") center / cover no-repeat`;
      }
      return _style;
    },
  },
  computed: {
    defaultImage() {
      return require("@/assets/images/user.svg");
    },
  },
  filters: {
    commaPoint(value) {
      if (value == 0) {
        return "0";
      } else if (value) {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    },
  },
  watch: {
    image: {
      handler() {
        this.dataItems.image = this.image;
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style scoped>
.box {
  height: 140px;
}

.style-box {
  position: absolute;
  top: 0px;
  height: 100%;
}
.style-sub-box {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.description-level {
  font-size: 0.9rem;
  color: #fafafa;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>
